import axiosInstance from './axiosInstance';

/**
 * 캐스팅 공고 목록 (공개 조회 — producerProfileId 필터 지원)
 * @param {{ status, projectType, producerProfileId, keyword, callpage, perpage }} params
 * @returns {{ content: Array, total: number, totalPages: number }}
 */
export const getCastingList = async (params) => {
  const res = await axiosInstance.get('/api/castings', { params });
  return res.data; // plain array
};

/**
 * 로그인한 프로듀서 본인 공고 목록
 * GET /api/castings/my
 * @param {{ status, keyword }} params  (선택)
 * @returns {{ content: Array, total: number, totalPages: number }}
 */
export const getMyCastingList = async (params = {}) => {
  const res = await axiosInstance.get('/api/castings/my', { params });
  return res.data; // plain array
};

/**
 * 캐스팅 공고 상세 (공개)
 * @param {number} id
 */
export const getCastingDetail = async (id) => {
  const res = await axiosInstance.get(`/api/castings/${id}`);
  return res.data;
};

/**
 * 캐스팅 공고 생성
 * @param {{ producerProfileId, title, projectType, category, regionProvince, regionCity,
 *           directorName, castingDirectorName, synopsis, referenceLink,
 *           applicationDeadline, roles, auditionStageDescriptions }} data
 * roles 필드: { roleName, roleType, gender, ageMin, ageMax, characterDesc }
 * @returns {{ id: number }}
 */
export const createCasting = async (data) => {
  const res = await axiosInstance.post('/api/castings', data);
  return res.data;
};

/**
 * 캐스팅 공고 수정
 * PUT /api/castings/{id}
 * @param {number} id
 * @param {object} data  (createCasting과 동일 형태)
 */
export const updateCasting = async (id, data) => {
  const res = await axiosInstance.put(`/api/castings/${id}`, data);
  return res.data;
};

/**
 * 캐스팅 공고 삭제
 * DELETE /api/castings/{id}  →  204 No Content
 * @param {number} id
 */
export const deleteCasting = async (id) => {
  await axiosInstance.delete(`/api/castings/${id}`);
};

/**
 * 캐스팅 공고 상태 변경
 * @param {number} id
 * @param {"OPEN"|"CLOSED"|"DRAFT"} status
 */
export const changeCastingStatus = async (id, status) => {
  await axiosInstance.patch(`/api/castings/${id}/status`, { status });
};

/**
 * 캐스팅 공고 조회수 증가
 * POST /api/castings/{id}/view → 200 OK
 * @param {number|string} id
 */
export const recordCastingView = async (id) => {
  await axiosInstance.post(`/api/castings/${id}/view`);
};

/**
 * 캐스팅 공고 총 조회수 조회
 * GET /api/castings/{id}/views → { postId, views }
 * @param {number|string} id
 */
export const getCastingViews = async (id) => {
  const res = await axiosInstance.get(`/api/castings/${id}/views`);
  return res.data; // { postId, views }
};
